// Skip cart everywhere: product page + Impulse quick view
(function () {
  // 1) Catch button clicks (Add / Shop now)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="add"], .product-form__submit, .add-to-cart');
    if (!btn) return;

    const form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    addAndGo(form);
  });

  // 2) Catch ENTER/submit on forms (accessibility)
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    addAndGo(form);
  });

  function addAndGo(form) {
    const data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
    .then(() => { window.location.assign('/checkout'); })
    .catch((err) => {
      console.error('Skip-cart error:', err);
      // Fallback: if something fails, just go to cart (rare)
      window.location.assign('/checkout');
    });
  }
})();